import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import InputWonForm from '../../../../../components/form/InputWonForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import BaseForm from '../../../../../components/form/BaseForm';
import { setNumberWithComma } from '../../../../../lib/common';
import {
  DELIVERY_CHARGE_JEJU_MAX_ETC,
  DELIVERY_CHARGE_JEJU_MAX_PRICE,
} from '../../../../../constants/service/app/productRegisterConstants';

const BrandDetailProductRegisterAddDeliveryCharge = (props) => {
  const { data, form, isEditable } = props;
  const { deliveryChargeJeju, deliveryChargeEtc, deliveryChargeReturn } = data;

  return (
    <Panel className="brand-detail-product-register-add-delivery-charge">
      <div className="panel-header">
        <div className="title">추가 배송비</div>
      </div>

      <div className="panel-body">
        {/*제주 추가 배송비*/}
        <InputWonForm
          label="제주 추가 배송비"
          form={form}
          rules={[formRequiredRules(true, null, null)]}
          max={DELIVERY_CHARGE_JEJU_MAX_PRICE}
          name="deliveryChargeJeju"
          isEditable={isEditable}
          initialValue={deliveryChargeJeju}
        />
        {/*제주외 도서산간 추가 배송비*/}
        <InputWonForm
          label="제주외 도서산간 추가 배송비"
          form={form}
          rules={[formRequiredRules(true, null, null)]}
          max={DELIVERY_CHARGE_JEJU_MAX_ETC}
          name="deliveryChargeEtc"
          isEditable={isEditable}
          initialValue={deliveryChargeEtc}
        />

        {/*반품/교환 배송비(편도)*/}
        {form.getFieldDecorator('deliveryChargeReturn', { initialValue: deliveryChargeReturn })(
          <BaseForm label="반품/교환 배송비(편도)" content={setNumberWithComma(deliveryChargeReturn, '원')} />,
        )}
      </div>
    </Panel>
  );
};

export default BrandDetailProductRegisterAddDeliveryCharge;
